export const convert_dd_mm_yy_to_milliseconds = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/").map(d => parseInt(d));
  return new Date(yy, mm - 1, dd).getTime();
};

export const convert_dd_mm_yy_to_Date = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/").map(d => parseInt(d));
  return new Date(yy, mm - 1, dd);
};

export const convert_date_time_string_to_Date = (date_string) => {}

export const convert_date_to_dd_mm_yyyy = (date) => {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0
  const yyyy = String(date.getFullYear());

  return `${dd}/${mm}/${yyyy}`;
};
